import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';

import {
  TextInput,
  FormGroup,
  RadioButton,
  RadioButtonGroup,
  FormLabel,
  Dropdown,
} from '@carbon/react';

import styles from './MicastAssignModalForm.module.scss';

import cx from 'classnames';
import { WizardForm, WizardStep } from '../../components/Wizard/WizardForm';
import { getLocationsForSelection } from '@/redux/new_services/locations';
import { checkDeviceKey, useAssignDeviceMutation } from '@/redux/new_services/device';
import { showToast } from '@/redux/new_services/toasts';

// brauchen wir das?
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const MicastModalForm = ({ locationID: propsLocationID, locationName, hideModal }) => {
  const dispatch = useDispatch();

  const [
    assignDevice,
    {
      isLoading: isSaving,
      error,
    }
  ] = useAssignDeviceMutation();

  const [locationID, setLocationID] = useState();
  const [currentSelectedID, setCurrentSelectedID] = useState({});
  const [keyCheckFailure, setKeyCheckFailure] = useState(false);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stateItem, setItem] = useState({
    label: '',
    key: '',
    orientation: 0,
  });
  const [keyChecked, setKeyChecked] = useState(true);
  const [locationError, setLocationError] = useState(false);
  const [locationChecked, setLocationState] = useState(true);
  const [labelChecked, setLabelChecked] = useState(true);

  useEffect(() => {

    console.info("trigger useEffect for getLocationsForSelection");
    // get all locations for this user
    // TODO: dafür kann ich jetzt auch ein RTK Query verwenden
    getLocationsForSelection('').then((data) => {
      setLocations(data);
      setLoading(false);
    }).catch((error) => {
      console.error(error);
    });

  }, [setLocations, setLoading]);

  useEffect(() => {
    setLocationID(propsLocationID);
  }, [propsLocationID]);

  useEffect(() => {
    setCurrentSelectedID(locations.find((l) => l.value === locationID) || {})
  },[locations, locationID, setCurrentSelectedID]);

  const doCheckDeviceKey = (key) => {
    setLoading(true);
    setKeyChecked(false);
    checkDeviceKey(key).then(data => {
      setKeyCheckFailure(!data);
      setLoading(false);
      setKeyChecked(data);
    });
  }

  const onChangeField = useCallback(
    (field, value) => {
      if (field === 'key') {
        if (stateItem.key !== value && keyChecked === true) {
          setKeyChecked(false);
        }
      }

      setItem({
        ...stateItem,
        [field]: value,
      });
    },

    [stateItem, setItem, keyChecked, setKeyChecked]
  );

  const handleSubmit = () => {
    setLoading(true);
    assignDevice({
      location_id: locationID,
      key: stateItem.key,
      label: stateItem.label,
      orientation: stateItem.orientation
    }).unwrap()
      .then((result) => {
        dispatch(showToast({kind: "success", title: "Micast-System Einrichtung", caption: "Das Micast-System wurde erfolgreich eingerichtet"}));
        setLoading(false);
        hideModal();
      })
      .catch((error) => {
        dispatch(showToast({kind: "error", title: "Micast-System Einrichtung", caption: `Das Micast-Systm konnte nicht eingrichtet werden. ${error} `}));
        setLoading(false);

      });
    //this.props.assignDevice(this.props.item.model.ID, this.state.item.label);

    //dispatch(
    //  deviceActions.assignToLocation(
    //    Number(locationID),
    //    stateItem.key,
    //    stateItem.label,
    //    stateItem.orientation
    //  )
    //);
  };

  const handleBeforeStepChange = (new_step, old_step) => {
    if (old_step === 2 && new_step === 3) {
      if (stateItem.key.length < 4) {
        setKeyChecked(false);
        return false;
      }

      doCheckDeviceKey(stateItem.key);

      return true;
    }

    if (old_step === 3 && new_step === 4) {
      // label checking
      if (stateItem.label.length < 1) {
        setLabelChecked(false)
        return false;
      }
      setLabelChecked(true);
      return true;

    }

    if (old_step === 1 && new_step === 2) {
      if (!locationID || locationID <= 0) {
        setLocationError(true);
        setLocationState(false);
        return false;
      }

      setLocationError(false);
      setLocationState(true);
    }

    return true;
  };

  const changeLocation = (lid) => {
    setLocationID(lid);
  };

  return (
    <WizardForm
      label="Micast-System einrichten"
      onAbort={hideModal}
      onSubmit={handleSubmit}
      onBeforeChangeStep={handleBeforeStepChange}
      isLoading={loading}
      max_steps={4}
      steps={[
        <WizardStep
          label="Standort"
          description="Schritt 1: Standort zuweisen"
          key="step1"
          validation={locationChecked}
          validation_error={locationError}
        >
          <FormGroup legendText="">
            <Dropdown
              id="form_create_device_location"
              label="Standort für Micast-System auswählen"
              items={locations}
              titleText="Wähle ein Standort für das Micast System aus"
              selectedItem={currentSelectedID}
              onChange={(e) => changeLocation(e.selectedItem.value)}
              invalid={locationError}
              invalidText={'Bitte wähle ein Standort aus'}
            />
          </FormGroup>
        </WizardStep>,
        <WizardStep
          label="Identifizieren"
          description="Schritt 2: Schlüssel vom Micast-System"
          validation={keyChecked}
          validation_error={keyCheckFailure}
          key="step2">
          <FormGroup legendText="">
            <TextInput
              labelText="Micast-Schlüssel"
              value={stateItem.key}
              id="form_create_device_key"
              autoComplete="off"
              autoCorrect="off"
              helperText="Schlüssel für das Micast Gerät (wie in der Anzeige)"
              invalid={
                keyCheckFailure === true || (stateItem.key.length !== 10 && stateItem.key.length > 8)
              }
              invalidText={
                keyCheckFailure === true
                  ? 'Dieser Schlüssel ist dem System nicht bekannt. Bitter überpüfe die Eingabe'
                  : 'Der Schlüssel muss Exakt 10 Zeichen lang sein!'
              }
              onChange={(e) =>
                onChangeField('key', e.target.value.toUpperCase().substr(0, 10))
              }
            />
          </FormGroup>
        </WizardStep>,
        <WizardStep
          label="Einstellungen"
          description="Schritt 3: Name vergeben"
          key="step3"
          validation={labelChecked}
        >
          <FormGroup legendText="">
            <TextInput
              labelText="Micast-Bezeichnung"
              value={stateItem.label}
              id="form_create_device_label"
              autoComplete="off"
              autoCorrect="off"
              invalid={stateItem.label.length < 1}
              invalidText={'Gebe dem Micast System einen Namen'}
              onChange={(e) => onChangeField('label', e.target.value)}
            />
            <FormLabel>Ausrichtung des Micast-Systems</FormLabel>
            <RadioButtonGroup
              orientation="vertical"
              valueSelected={stateItem.orientation + 1 || 1}
              name="form_device_orientation"
              onChange={(e) => onChangeField('orientation', e - 1)}>
              <RadioButton value={1} labelText="Querformat" />
              <RadioButton value={2} labelText="Hochkant Darstellung" />
            </RadioButtonGroup>
            <div className="cds--form__helper-text">
              Lege die Ausrichtung des Systems fest.
            </div>
          </FormGroup>
        </WizardStep>,
        <WizardStep label="Prüfen" description="Schritt 4: Prüfen" key="step4">
          <FormGroup legendText="">
            <p className={cx(styles.SummaryText)}>
              Aktiviere <span>{stateItem.label || ''}</span>
              <br />
              Im Standort&nbsp;<span>{locationName}</span>&nbsp; mit dem
              Schlüssel &nbsp;<span>{stateItem.key}</span>
            </p>
            <br />
          </FormGroup>
        </WizardStep>,
      ]}
    />
  );
};

export default MicastModalForm;
